/**
 * MobX store classes instantiation.
 * This is where all MobX stores are instantiated
 * and exported for use within the Provider.
 */
import { configurePersistable } from 'mobx-persist-store';
import React from 'react';
import { configure } from 'mobx';
import UserStore from './UserStore';
import BusinessStore from './BusinessStore';
import WalletStore from './WalletStore';
import SupportStore from './SupportStore';
import CustomerStore from './CustomerStore';
import TransactionStore from './TransactionStore';
import InvoiceStore from './InvoiceStore';
import AppStore from './AppStore';
import ExchangeStore from './ExchangeStore';
import PaymentLinkStore from './PaymentLinkStore';
import BookingStore from './BookingStore';
import QuotationStore from './QuotationStore';
import GeneralNotificationStore from './GeneralNotificationStore';
import ReportStore from './ReportStore';
/**
 * Configuration to ensure all state changes occur via MobX actions
 */

configure({ enforceActions: 'observed' });
configurePersistable(
	{
		storage: window.localStorage,
		expireIn: 86400000,
		removeOnExpiration: true,
		stringify: true,
		debugMode: false,
	},
	{ delay: 200, fireImmediately: false }
);

export const appStore = new AppStore();

export const userStore = new UserStore();

export const businessStore = new BusinessStore();

export const walletStore = new WalletStore();

export const supportStore = new SupportStore();

export const customerStore = new CustomerStore();

export const transactionStore = new TransactionStore();
export const invoiceStore = new InvoiceStore();
export const exchangeStore = new ExchangeStore();
export const paymentLinkStore = new PaymentLinkStore();
export const bookingStore = new BookingStore();

export const quotationStore = new QuotationStore();
export const generalNotificationStore = new GeneralNotificationStore();
export const reportStore = new ReportStore();

export const storesContext = React.createContext({
	userStore,
	businessStore,
	walletStore,
	appStore,
	customerStore,
	supportStore,
	transactionStore,
	invoiceStore,
	exchangeStore,
	paymentLinkStore,
	quotationStore,
	bookingStore,
	generalNotificationStore,
});

export const useStores = () => React.useContext(storesContext);
